import { Box, Button, Typography } from '@material-ui/core'
import { useState } from 'react'
import { useAppSelector } from 'utils/reduxHelpers'

import DeleteDeviceAction from '../../List/components/DeleteDeviceAction'
import FactoryResetAction from '../../List/components/FactoryResetAction'
import FullCleanupAction from '../../List/components/FullCleanupAction'
import RestartDeviceAction from '../../List/components/RestartDeviceAction'
import EditArcAssignmentModal from './editArcAssignment/EditArcAssignmentModal'
import { useStyles } from './style'
import { CertificateStatus } from './types'
import { getAuthToken } from './utils'

type DeviceActionsProps = {
  imei: string
  deviceId: string
  serialNumber: string
  isArcDevice?: boolean
  onOpenSnackbar: () => void
  setSnackbarMessage: (message: string) => void
  refresh: () => void
  certificateStatus: CertificateStatus
  setCertificateStatus: (certificateStatus: CertificateStatus) => void
}

const DeviceActions = ({
  imei,
  deviceId,
  serialNumber,
  onOpenSnackbar,
  setSnackbarMessage,
  refresh,
  certificateStatus,
  setCertificateStatus,
  isArcDevice = false,
}: DeviceActionsProps) => {
  const style = useStyles()
  const [editModalOpen, setEditModalOpen] = useState(false)
  const organizationId = useAppSelector(
    (state) => state.devicesReducer.deviceDetailsReducer.organizationId
  )
  const organizationName = useAppSelector(
    (state) => state.devicesReducer.deviceDetailsReducer.organizationName
  )
  const allowedLocationIds = useAppSelector(
    (state) => state.devicesReducer.deviceDetailsReducer.allowedLocationIds
  )
  const nickname = useAppSelector(
    (state) => state.devicesReducer.deviceDetailsReducer.nickname
  )

  const disassocateDevice = async () => {
    await fetch(
      `${process.env.REACT_APP_API_URL}/api/secured/devices/manage/${imei}/disassociate`,
      {
        method: 'DELETE',
        credentials: 'include',
        cache: 'no-cache',
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
          Cookie: document.cookie,
        },
      }
    )

    refresh()
  }

  const refreshCertificate = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/secured/devices/${imei}/certificate/refresh`,
      {
        method: 'PUT',
        credentials: 'include',
        cache: 'no-cache',
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
          Cookie: document.cookie,
        },
      }
    )

    const data = await response.json()

    setCertificateStatus(data.certificateStatus)
  }

  const isCertificateActive = certificateStatus === 'ACTIVE'

  return (
    <>
      <Typography variant="h4">Actions</Typography>
      <Box className={style.actionContainer}>
        {isArcDevice && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => setEditModalOpen(true)}
            className={style.button}
          >
            Edit Device
          </Button>
        )}
        <Button
          variant="contained"
          onClick={disassocateDevice}
          className={style.button}
        >
          Disassociate
        </Button>
        <FullCleanupAction id={deviceId} serialNumber={serialNumber} />
        <DeleteDeviceAction id={deviceId} serialNumber={serialNumber} />
        <RestartDeviceAction
          id={deviceId}
          onOpenSnackbar={onOpenSnackbar}
          setSnackbarMessage={setSnackbarMessage}
        />
        <FactoryResetAction
          id={deviceId}
          onOpenSnackbar={onOpenSnackbar}
          setSnackbarMessage={setSnackbarMessage}
        />
        {/* {!isCertificateActive && ( */}
        <Button
          variant="contained"
          color="primary"
          onClick={refreshCertificate}
          className={style.button}
        >
          Refresh Certificate
        </Button>
        {/* )} */}
      </Box>
      {isArcDevice && (
        <EditArcAssignmentModal
          open={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          deviceId={deviceId}
          organizationId={organizationId}
          organizationName={organizationName}
          allowedLocationIds={allowedLocationIds}
          nickname={nickname}
        />
      )}
    </>
  )
}

export default DeviceActions
